import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent, MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { AppUser } from '@classes/auth/infosUser';
import { Camera } from '@classes/camera/camera';
import { faInfoCircle, faSearch, faCar, faPlus, faVideo, faCog, faPen, faRedo, faCogs, faInfo } from '@fortawesome/free-solid-svg-icons';
import { CamerasService } from '@services/cameras/cameras.service';
import { DataService } from '@services/data/data.service';
import { RolesService } from '@services/roles/roles.service';
import { SmartparkingCameraInfosLastSyncComponent } from 'app/components/smartparking/smartparking-camera-infos-last-sync/smartparking-camera-infos-last-sync.component';
import { SmartparkingCamerasAddComponent } from 'app/components/smartparking/smartparking-cameras-add/smartparking-cameras-add.component';
import { SmartparkingCamerasConfigComponent } from 'app/components/smartparking/smartparking-cameras-config/smartparking-cameras-config.component';
import { CameraWasteService } from '@services/cameraWaste/CameraWasteService';
import { CameraWaste } from '@classes/waste-camera/waste-camera';
import { CameraOptionComponent } from '../camera-option/camera-option.component';
import { ActionComponent } from '../action/action.component';

@Component({
  selector: 'app-application-camera-table',
  templateUrl: './application-camera-table.component.html',
  styleUrls: ['./application-camera-table.component.scss']
})
export class ApplicationCameraTableComponent implements OnInit {

  @Input() cameras: Camera[];

  faInfoCircle = faInfoCircle;
  faSearch = faSearch;
  faCar = faCar;
  faPlus = faPlus;
  faVideo = faVideo;
  faInfo = faInfo;
  faCogs = faCogs;
  faPen = faPen;
  faRedo = faRedo;
  // displayedColumnsAdmin: string[] = ['name', 'ip', 'port', 'syncTime', 'numbCars', 'lastSync', 'config', 'edit'];
  displayedColumns: string[] = ['name', 'application', 'lastLogon', 'battery', 'lastSync', 'info', 'action'];
  dataSource: MatTableDataSource<Camera>;


  length: number;
  pageSize = 5;
  pageSizeOptions: number[] = [5, 10, 25, 50];
  pageEvent: PageEvent;
  color: ThemePalette = 'primary';
  isAdmin: boolean;
  cameraWaste: CameraWaste[];

  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  show = false;
  userAppSelected: AppUser;


  constructor(
    private cameraService: CamerasService,
    private dialog: MatDialog,
    private dataService: DataService,
    public router: Router,
    private roleService: RolesService,
  ) {

  }

  ngOnInit(): void {

    this.roleService.getRoleUserApp();
    this.userIsAdmin();
    this.getCameras();
    // this.initSub();

  }

  goToSlots(camera: Camera): void {
    const queryparams = { name: camera.name, id: camera.id, ip: camera.ip };
    this.router.navigate(['/smartparking/slots'], { queryParams: queryparams });
  }


  applyFilter(filterValue): void {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  openDialogInfoCamera(camera: Camera): void {
    const dialogRef = this.dialog.open(SmartparkingCameraInfosLastSyncComponent, {
      data: { camera }
    });

  }

  openDialogAddCamera(): void {
    const dialogRef = this.dialog.open(SmartparkingCamerasAddComponent);

    dialogRef.afterClosed().subscribe(() => {
      this.getCameras();
    });
  }

  openDialogOptionCamera(camera: Camera): void {
    const dialogRef = this.dialog.open(CameraOptionComponent, {
      data: { camera }
    });
  }

  openDialogAction(camera: Camera): void {
    const dialogRef = this.dialog.open(ActionComponent, {
      data: { camera },
      width: '40%'
    });
  }

  openConfigCamera(element: Camera): void {
    const dialogRef = this.dialog.open(SmartparkingCamerasConfigComponent, {
      data: { camera: element }
    });
  }

  showElement(): void {
    setTimeout(() => {
      this.show = true;
    }, 150);
  }

  private userIsAdmin(): void {
    this.userAppSelected?.roleUser === 'Admin' ?
      this.dataService.isAdmin.next(true) :
      this.dataService.isAdmin.next(false);
  }

  private getCameras(): void {

    this.dataSource = new MatTableDataSource<Camera>(this.cameras);
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;

    // this.cameraService.getCameras().subscribe(res => {
    //   this.dataSource = new MatTableDataSource<Camera>(res);
    //   this.dataSource.sort = this.sort;
    //   this.dataSource.paginator = this.paginator;
    // });
  }



}

